import React, { Suspense, useState } from 'react';
import Modal from 'components/commons/modal';
import whatsapp from 'assets/svg/whatsapp-green.svg';
import copy from 'assets/svg/copy.svg';
import WhatsAppForm from './whatsapp-form/whatsapp-form';
import CopyLinkForm from './copy-link-form/copy-link-form';

type ShareUrlProps = {
    url: string;
    whatsappMessage: string;
    onClick?: () => void;
}

const ShareUrl: React.FC<ShareUrlProps> = ({ url, whatsappMessage, onClick }) => {
    const [modalWhatsAppVisible, setModalWhatsAppVisible] = useState(false);
    const [modalCopyLinkVisible, setModalCopyLinkVisible] = useState(false);

    return (
        <>
            <div className="l-documents-screen__invitation--items">
                <a href="#" onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
                    setModalWhatsAppVisible(true);
                }}>
                    <div className="l-documents-screen__invitation--item">
                        <img src={whatsapp} className="mb-2" role='presentation' />
                        <p className="caption lg:body-2 medium">WhatsApp</p>
                    </div>
                </a>
                <a href="#" onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
                    setModalCopyLinkVisible(true);
                }}>
                    <div className="l-documents-screen__invitation--item">
                        <img src={copy} className="mb-2" role='presentation' />
                        <p className="caption lg:body-2 medium">Copiar Link</p>
                    </div>
                </a>
            </div>

            <Suspense fallback="">
                <Modal
                    title=""
                    fitMobileScreen={false}
                    visible={modalWhatsAppVisible}
                    onClose={() => setModalWhatsAppVisible(false)}
                >
                    <div className="l-documents-screen__invitation--modal-content">
                        <WhatsAppForm
                            whatsappMessage={whatsappMessage} onSent={() => setModalWhatsAppVisible(false)}
                            onClick={ ()=> {
                                if(onClick) {
                                    onClick()
                                }
                            }} />
                    </div>
                </Modal>
                <Modal
                    title=""
                    fitMobileScreen={false}
                    visible={modalCopyLinkVisible}
                    onClose={() => setModalCopyLinkVisible(false)}
                >
                    <div className="l-documents-screen__invitation--modal-content">
                        <CopyLinkForm
                        onClick={ ()=> {
                            if(onClick) {
                                onClick()
                            }
                        }}
                        url={url} />
                    </div>
                </Modal>
            </Suspense>
        </>
    )
};

export default ShareUrl;
